import { fieldsNames } from '../constants';
import { ExcludeCountryRule } from '../types';
import { getCardHolderValidation } from './cardHolder';
import { getCardNumberValidation } from './cardNumber';
import { getCvvValidation } from './cvv';
import { getMonthValidation } from './month';
import { getYearValidation } from './year';

import * as yup from 'yup';

type Params = {
  excludeCardCountryCodes: ExcludeCountryRule[];
};

export const getValidation = (params?: Params) => {
  const { excludeCardCountryCodes = [] } = params || {};

  return {
    [fieldsNames.cardNumber]: yup.string().when(fieldsNames.id, {
      is: (id: string) => !id,
      then: getCardNumberValidation({ excludeCardCountryCodes }),
    }),

    [fieldsNames.month]: yup.string().when(fieldsNames.id, {
      is: (id: string) => !id,
      then: getMonthValidation(),
    }),

    [fieldsNames.year]: yup.string().when(fieldsNames.id, {
      is: (id: string) => !id,
      then: getYearValidation(),
    }),

    [fieldsNames.cvv]: getCvvValidation(),
    [fieldsNames.cardHolder]: yup.string().when(fieldsNames.id, {
      is: (id: string) => !id,
      then: getCardHolderValidation(),
    }),
    [fieldsNames.saveCard]: yup.boolean(),
  };
};
